import { render, staticRenderFns } from "./ReplyTypes.vue?vue&type=template&id=860e2f6c&"
import script from "./ReplyTypes.vue?vue&type=script&lang=js&"
export * from "./ReplyTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports